// Page expandableTableRowKeyText
$(document).ready(function() {
	let $controlPlus = $('.tableRowKeyFourValuesWithExpandableText a.controlPlus');
	let $controlMinus = $('.tableRowKeyFourValuesWithExpandableText a.controlMinus');

	if (!$controlPlus.length || !$controlMinus.length) {
		return;
	}

	$controlPlus.click(function () {
		let $this = $(this);

		$('.tableRowKeyFourValuesWithExpandableText').removeClass('expanded');
		$this.parents('.tableRowKeyFourValuesWithExpandableText').addClass('expanded');

		$('html, body').animate({
			scrollTop: ($('body>div.content').offset().top * -1) + $this.parents('.tableRowKeyFourValuesWithExpandableText').offset().top - 10,
		}, 700);

		return false;
	});

	$controlMinus.click(function () {
		let $this = $(this);

		$('.tableRowKeyFourValuesWithExpandableText').removeClass('expanded');

		$('html, body').animate({
			scrollTop: ($('body>div.content').offset().top * -1) + $this.parents('.tableRowKeyFourValuesWithExpandableText').offset().top - 10,
		}, 700);

		return false;
	});
});
